









import { Vue, Component } from 'vue-property-decorator';
import { Button, Popup } from 'vant';
Vue.use(Button).use(Popup);
@Component
export default class Slider extends Vue {
  show = false;
  opened() {
    window.initSlide({
      // 调用window上的initSlide方法
      id: 'slider', // 传入的id，对应你dome上写的id
      success: (res: any) => {
        // 调起滑块的回调
        console.log(res);
      },
    });
  }
}
